import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=7492d69e&scoped=true&"
import script from "./Talent.vue?vue&type=script&lang=js&"
export * from "./Talent.vue?vue&type=script&lang=js&"
import style0 from "./Talent.vue?vue&type=style&index=0&id=7492d69e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7492d69e",
  null
  
)

export default component.exports